import { DateTime } from 'luxon';
import { EldMalfunctionsState } from '../types';

import { DEFAULT_ROWS_PER_PAGE } from 'app/constants/paginate';

export const eldMalfunctionsState: EldMalfunctionsState = {
  eldMalfunctions: [],
  eldMalfunctionsReportData: [],
  sortBy: '-begin-timestamp',
  sortField: 'begin-timestamp',
  event: null,
  driver: null,
  status: null,
  vehicles: null,
  dateRange: {
    fromDate: DateTime.now().minus({ days: 6 }).toISO(),
    toDate: DateTime.now().toISO(),
  },
  remarksKeyword: '',
  malfunctionsAndDiagnostics: null,
  limit: DEFAULT_ROWS_PER_PAGE,
  offset: 0,
  totalRecordCount: 0,
  documentType: 'pdf',
  paperOrientation: 'portrait',
  isRequestPending: false,
  isToggleExportFileModal: false,
  isVehicleFilterMenuClosed: false,
  isExportDataRequestPending: false,
};
